import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, Link } from '@mui/material';
import { IDownloadButton } from "./IDownloadButton";



export default function DownloadButton({ downloadLink, title }: IDownloadButton) {
    return (
        <>
            <div>
                <Link
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginY: '1rem',
                        width: '100%',
                        border: "1px solid #BBA57A",
                        borderRadius: "5px"
                    }}
                    href={downloadLink?.fileUrl}
                    download="قرارداد"
                    underline="none"
                    target="_blank"
                    rel="noopener"
                >
                    <FileDownloadOutlinedIcon
                        sx={{
                            color: '#BBA57A',
                            fontWeight: 'bold',
                            fontSize: '1.5rem',
                        }}
                    />
                    <Button
                        sx={{
                            color: '#BBA57A',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            paddingRight: '.1em',
                        }}
                    >
                        {title}
                    </Button>
                </Link>
            </div>
        </>
    )
}